 <h4 mat-dialog-title>
    TeamMood tips
</h4>

<div mat-dialog-content class="dialog-content-pad-15">
    <h1>{{data.tip.title}}</h1>
    <div [innerHtml]="data.tip.htmlBody"></div>
</div>

<div mat-dialog-actions>
    <button [mat-dialog-close]="false"
        type="button"
        class="btn btn-default">{{ 'close' | translate}}</button>
</div>
